// Libs
import React from 'react';
// Utils
import { getSelectedPaycuts } from 'utils/filters/Billings/paycuts';
// Components
import { HamburguerIcon, AddIcon } from 'components';
import { CustomToolbar } from '../../sharedFunctions';
import ToolbarBackButton from '../../ToolbarBackButton';
// Styles
import '../../index.css';

export function InvoicePays(props) {
	const {
		title,
		showNavBar,
		selectNotification,
		mutate1ObjectInBillings,
		apiPayments,
		paycutsManage,
		profile,
		onClickBackButton,
	} = props;
	const selectedPaycuts = getSelectedPaycuts(
		apiPayments.paycuts.data,
		paycutsManage.selected.items,
	);
	const firstSelectedPaycut = selectedPaycuts[0];

	return (
		<CustomToolbar
			selectNotification={selectNotification}
			title={title}
			left={
				profile?.entity?.id === profile?.organization?.settings?.mainEntity ? (
					<ToolbarBackButton handleOnClick={onClickBackButton} />
				) : (
					<HamburguerIcon button onClick={showNavBar} />
				)
			}
			right={
				<>
					{/* Add Payment */}
					{selectedPaycuts.length === 1 &&
						firstSelectedPaycut?.state === 'open' && (
							<AddIcon
								button
								onClick={() =>
									mutate1ObjectInBillings('createPaymentModal', {
										isOpen: true,
									})
								}
							/>
						)}
				</>
			}
		/>
	);
}
